<template>
    <div>
        <page-header title="New Approval Workflow" :back="'/settings/approval'" breadcrumb="Dashboard >> Settings >> Approval >> New Approval Workflow" />
        <div class="custom-card">
            <div class="font-semibold text-lg my-3">Module Details</div>
            <div class="text-sm">
                Start by selecting a module, then a list of actions or forms within that module can be selected. You can select more than one actions/forms to configure for approval. You can only select multiple actions/forms within one module though.
            </div>
            <div class="flex flex-row justify-between mt-3">
                <div>
                    <label class="font-semibold text-sm">Module Name</label>
                    <el-select filterable v-model="state" style="width: 442px; display: block" placeholder="Select">
                        <el-option label="state.name" value="state.name"> </el-option>
                    </el-select>
                </div>
                <div>
                    <label class="font-semibold text-sm">Sub Module</label>
                    <el-select filterable v-model="state" style="width: 442px; display: block" placeholder="Select">
                        <el-option label="state.name" value="state.name"> </el-option>
                    </el-select>
                </div>
            </div>
            <div class="text-sm">
                Select a module to see associated actions/forms:
            </div>
            <div class="flex my-3 flex-row">
                <div class=" col-6">
                    <div class="font-semibold text-base">Actions</div>
                    <div class="my-3 text-sm">
                        <b-form-checkbox>
                            Manage visit logs
                        </b-form-checkbox>
                        <b-form-checkbox>
                            Manage visit logs
                        </b-form-checkbox>
                        <b-form-checkbox>
                            Manage visit logs
                        </b-form-checkbox>
                        <b-form-checkbox>
                            Manage visit logs
                        </b-form-checkbox>
                    </div>
                </div>
                <div class="border h-auto"></div>
                <div class=" col-6 ml-3">
                    <div class="font-semibold text-base">Forms</div>

                    <div class="my-3 text-sm">

                        <b-form-checkbox>
                            Manage visit logs
                        </b-form-checkbox>
                        <b-form-checkbox>
                            Manage visit logs
                        </b-form-checkbox>
                        <b-form-checkbox>
                            Manage visit logs
                        </b-form-checkbox>
                        <b-form-checkbox>
                            Manage visit logs
                        </b-form-checkbox>
                    </div>
                </div>
            </div>
            <hr />
            <div class="font-semibold my-4 text-lg">
                Location and Function Settings
            </div>
            <div class="text-sm">
                Now select which locations this workflow is going to be configured for. This implies that the approval process will be in effect for only selected locations. This principle also applies to selected functions. This is very effective where approval flows
                vary based on location, or function (departments). Simply select all for each, if the workflow is the same organisation, regardless of users’ location or function.
            </div>
            <div class="flex flex-row my-4 justify-between">
                <div>
                    <label class="text-sm flex flex-row justify-between">
                <span class="font-semibold">Location(s)</span>
                <span>
                  <b-form-checkbox> Select All Locations </b-form-checkbox></span
                >
              </label>
                    <el-select filterable v-model="state" style="width: 442px; display: block" placeholder="Select">
                        <el-option label="state.name" value="state.name"> </el-option>
                    </el-select>
                </div>
                <div>
                    <label class="text-sm flex flex-row justify-between">
                <span class="font-semibold">Function(s)</span>
                <span>
                  <b-form-checkbox> Select All Functions </b-form-checkbox></span
                >
              </label>
                    <el-select filterable v-model="state" style="width: 442px; display: block" placeholder="Select">
                        <el-option label="state.name" value="state.name"> </el-option>
                    </el-select>
                </div>
            </div>
            <hr />
            <div class="my-4 font-semibold text-lg">Approval Workflow</div>
            <div class="text-sm">
                This is the final step. Select your prefered workflow and build your aprroval trail.
            </div>
            <div>
                <div class="text-success text-base font-semibold my-3">Approval Type</div>
            <div class="flex flex-row">
                <div class="col-6">
                    <span class="font-semibold"><b-form-radio v-model="approvalType" name="approval-type" value="manual">Manual</b-form-radio></span>
                    <div class="border-l-2 ml-2 border-dashed h-16 p-3 text-sm">
                        <div class="">
                            Let me select the approvers directly, irrespective of my organization’s hierarchy.
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <span class="font-semibold"><b-form-radio v-model="approvalType" name="approval-type" value="dynamic">Dynamic</b-form-radio></span
              >
              <div class="border-l-2 ml-2 border-dashed h-16 p-3 text-sm">
                <div class="">
                  Let me select the approvers directly, irrespective of my
                  organization’s hierarchy.
                </div>
              </div>
            </div>
          </div>
            </div>
            
          <div class="text-success text-base font-semibold my-3">Approval Flow</div>
         <manual-flow v-if="approvalType==='manual'"></manual-flow>
         <dynamic-flow v-if="approvalType==='dynamic'"></dynamic-flow>
    <hr />
    
    <div class="flex flex-row my-5 justify-between">
        <base-button background="white" text="Cancle" @click="$router.push('/settings/approval')" ></base-button>
        <base-button text="Save"></base-button>
    </div>
    </div>
    </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import ManualFlow from './ManualFlow.vue'
import DynamicFlow from './DynamicFlow.vue'
export default {
    components: {
        PageHeader,
        ManualFlow, DynamicFlow
    },
    data() {
        return {
            approvalStructure: "manual",
            
            approvalType: 'manual'
        };
    },
    methods: {
       
    },
};
</script>

<style scoped>

</style>
